import React from "react";
import Layout from "../../components/Layout";
import ScrollToTop from "../../components/ScrollToTop";
import SessionCheck from "../../components/SessionCheck";
import NavHeader from "../../components/NavHeader";
import MortgageCategories from "../../sections/Mortgage/mortgage-categories";

const MortgageCategoryPage = () => {
  return (
    <Layout>
      <ScrollToTop />
      <SessionCheck shouldRedirect />
      <NavHeader pageTitle="Mortgage" routeName="mortgage" />
      <MortgageCategories />
    </Layout>
  );
};
 
export default MortgageCategoryPage;
